export default "__VITE_ASSET__D5GzCGyH__"